var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Panel',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" Add Credit Card ")]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"w-50"},[_c('CreditCardForm',{attrs:{"is-loading":_vm.isLoading},on:{"submit":_vm.onSubmit,"success":_vm.onSuccess,"error":_vm.onError}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }